import { render, staticRenderFns } from "./GlpCard.vue?vue&type=template&id=549239c4&"
import script from "./GlpCard.vue?vue&type=script&lang=ts&"
export * from "./GlpCard.vue?vue&type=script&lang=ts&"
import style0 from "./GlpCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.2_1ebeed51c9db1c19ddd7ada5173f91fd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports